import {
	i as e,
	n as t,
	o as n,
	t as r,
} from "./cart-add-intercept-L_Xl4fqj.js";
(() => {
	let i = window.Difrax?.sectionLifecycle;
	if (!i) return;
	let a = (e, t) =>
		window.Shopify && typeof window.Shopify.formatMoney == `function`
			? window.Shopify.formatMoney(e, t)
			: new Intl.NumberFormat(document.documentElement.lang || `nl-NL`, {
					style: `currency`,
					currency:
						(window.Shopify &&
							window.Shopify.currency &&
							window.Shopify.currency.active) ||
						`EUR`,
				}).format(e / 100);
	class o {
		form;
		gallery;
		moneyFormat;
		optionNames;
		section;
		variants;
		constructor(e) {
			(this.section = e),
				(this.form = e.querySelector(`[data-product-form]`)),
				(this.variants = this.getVariants()),
				(this.optionNames = this.getOptionNames()),
				(this.moneyFormat =
					e.dataset.moneyFormat ||
					window.DifraxMoneyFormat ||
					`{{amount_with_comma_separator}}`),
				(this.gallery = null),
				this.bindGallery(),
				this.bindKeyFeatures(),
				this.bindQuantity(),
				this.bindAddToCart(),
				this.bindStickyAtc(),
				this.bindVariants();
		}
		getVariants() {
			let e = this.section.querySelector(`[data-product-variants]`);
			if (!e) return [];
			try {
				let t = JSON.parse(e.textContent),
					n = this.section.querySelector(`[data-product-variant-stock]`),
					r = n ? JSON.parse(n.textContent || `[]`) : [],
					i = new Map(r.map((e) => [String(e.id), e]));
				return t.map((e) => ({ ...e, ...(i.get(String(e.id)) || {}) }));
			} catch {
				return [];
			}
		}
		getOptionNames() {
			let e = this.section.querySelector(`[data-product-option-names]`);
			if (!e) return [];
			try {
				return JSON.parse(e.textContent);
			} catch {
				return [];
			}
		}
		syncArticleNumber(e) {
			let t = String(e?.sku || ``).trim();
			this.section
				.querySelectorAll(`[data-product-article-number-accordion]`)
				.forEach((e) => {
					let n = e.querySelector(`[data-product-article-number-list]`),
						r = e.querySelector(`[data-product-article-number]`);
					r && (r.textContent = t),
						n && (n.hidden = t === ``),
						(e.hidden = e.dataset.hasContent !== `true` && t === ``);
				});
		}
		syncVariantDetailBlocks(e) {
			let t = Array.from(
				this.section.querySelectorAll(`[data-product-variant-detail-block]`),
			);
			if (t.length === 0) return;
			let n = (e) =>
				String(e || ``)
					.trim()
					.toLowerCase()
					.normalize(`NFD`)
					.replace(/[\u0300-\u036f]/g, ``)
					.replace(/[^a-z0-9]+/g, `-`)
					.replace(/^-+|-+$/g, ``);
			t.forEach((t) => {
				let r = n(t.dataset.optionName),
					i = this.optionNames.findIndex((e) => n(e) === r),
					a = i >= 0 ? n(e?.options?.[i]) : ``;
				Array.from(
					t.querySelectorAll(`[data-product-variant-detail-icon]`),
				).forEach((e) => {
					let t = n(e.dataset.optionValue),
						r = n(e.dataset.filterMatchValue) !== `` || (a !== `` && t === a);
					if ((e.classList.toggle(`is-active`, r), r)) {
						e.setAttribute(`aria-current`, `true`);
						return;
					}
					e.removeAttribute(`aria-current`);
				});
			});
		}
		syncStickyAtc(e) {
			let t = this.section.querySelector(`[data-sticky-atc]`);
			if (!t) return;
			let n = t.querySelector(`[data-sticky-product-price]`),
				r = t.querySelector(`[data-sticky-compare-price]`),
				i = t.querySelector(`[data-sticky-add-to-cart]`),
				o = t.querySelector(`[data-sticky-add-to-cart-text]`),
				s = t.querySelector(`[data-sticky-discount-badge]`),
				c = t.querySelector(`[data-sticky-product-image]`);
			if (!e) {
				i && (i.disabled = !0);
				return;
			}
			if ((n && (n.textContent = a(e.price, this.moneyFormat)), r)) {
				let t = e.compare_at_price && e.compare_at_price > e.price;
				(r.hidden = !t),
					(r.textContent = t ? a(e.compare_at_price, this.moneyFormat) : ``);
			}
			if (
				(i && (i.disabled = !e.available),
				o &&
					(o.textContent = e.available
						? o.dataset.availableText || o.textContent
						: o.dataset.soldOutText || `Uitverkocht`),
				s)
			) {
				let t = e.compare_at_price && e.compare_at_price > e.price;
				if (((s.hidden = !t), t)) {
					let t = Math.round(
						((e.compare_at_price - e.price) * 100) / e.compare_at_price,
					);
					s.textContent = (s.dataset.discountTemplate || `[percent]% korting`)
						.replace(`[percent]`, String(t))
						.replace(`{{ percent }}`, String(t));
				}
			}
			if (c) {
				let t =
					e.featured_image?.src ||
					e.featured_media?.preview_image?.src ||
					e.image?.src ||
					c.dataset.fallbackSrc;
				t && (c.removeAttribute(`srcset`), (c.src = t)),
					(c.alt =
						e.featured_image?.alt || e.featured_media?.alt || c.alt || ``);
			}
		}
		bindGallery() {
			let e = this.section.querySelector(`.product-detail__gallery`),
				t = this.section.querySelector(`[data-product-media-carousel]`),
				n = this.section.querySelector(`[data-product-media-track]`),
				r = Array.from(
					this.section.querySelectorAll(`[data-product-media-slide]`),
				),
				i = Array.from(this.section.querySelectorAll(`[data-product-thumb]`)),
				a = this.section.querySelector(`[data-product-slider-prev]`),
				o = this.section.querySelector(`[data-product-slider-next]`),
				s = this.section.querySelector(`[data-product-media-status]`),
				c = Array.from(
					this.section.querySelectorAll(`[data-product-media-dot]`),
				),
				l = this.section.querySelector(`[data-product-media-zoom]`),
				u = this.section.querySelector(`[data-product-media-zoom-dialog]`),
				d = this.section.querySelector(`[data-product-media-zoom-close]`),
				f = this.section.querySelector(`[data-product-media-zoom-content]`);
			if (!t || !n || r.length === 0) return;
			let p = 0,
				m = null,
				h = (e?.dataset.productGalleryLayout || ``).includes(`carousel`),
				g = [...r],
				_ = (e) => Math.min(Math.max(e, 0), Math.max(g.length - 1, 0)),
				v = (e) =>
					e instanceof HTMLIFrameElement &&
					/(youtube\.com|youtube-nocookie\.com)/.test(e.src),
				y = (e) => e instanceof HTMLIFrameElement && /vimeo\.com/.test(e.src),
				b = (e, t) => {
					!v(e) ||
						!e.contentWindow ||
						e.contentWindow.postMessage(
							JSON.stringify({ event: `command`, func: t, args: [] }),
							`*`,
						);
				},
				x = (e, t) => {
					!y(e) ||
						!e.contentWindow ||
						e.contentWindow.postMessage({ method: t }, `*`);
				},
				S = (e) => {
					if (!(e instanceof HTMLIFrameElement)) return !1;
					let t = e.dataset.productMediaSrc || e.src;
					e.dataset.productMediaSrc = t;
					let n;
					try {
						n = new URL(e.src || t, window.location.href);
					} catch {
						return !1;
					}
					return n.searchParams.get(`autoplay`) === `1`
						? !1
						: (n.searchParams.set(`autoplay`, `1`),
							v(e) &&
								(n.searchParams.set(`mute`, `1`),
								n.searchParams.set(`playsinline`, `1`),
								n.searchParams.set(`enablejsapi`, `1`)),
							y(e) && n.searchParams.set(`muted`, `1`),
							(e.src = n.toString()),
							!0);
				},
				C = (e) => {
					if (!(e instanceof HTMLIFrameElement)) return;
					let t = e.dataset.productMediaSrc;
					!t || e.src === t || (e.src = t);
				},
				w = (e, t) => {
					if (e instanceof HTMLIFrameElement) {
						if (
							((e.dataset.productMediaShouldPlay = t ? `true` : `false`), t)
						) {
							S(e)
								? e.addEventListener(
										`load`,
										() => {
											e.dataset.productMediaShouldPlay === `true` &&
												(b(e, `playVideo`), x(e, `play`));
										},
										{ once: !0 },
									)
								: (b(e, `playVideo`), x(e, `play`));
							return;
						}
						b(e, `pauseVideo`), x(e, `pause`), C(e);
					}
				},
				T = () => {
					r.forEach((t) => {
						let n = t === g[p],
							r = t.querySelector(`video`),
							i = t.querySelector(`iframe`);
						r &&
							((r.loop = e?.dataset.videoLoop === `true`),
							(r.muted = e?.dataset.videoAutoplay === `true`),
							n && e?.dataset.videoAutoplay === `true`
								? r.play().catch(() => {})
								: r.pause()),
							i && w(i, n && e?.dataset.videoAutoplay === `true`);
					});
				},
				E = (e) => {
					if (!u || !f) return;
					let t = f.parentElement;
					if (!t) return;
					let n = (e) => Number.parseFloat(e) || 0,
						r = window.getComputedStyle(u),
						i = window.getComputedStyle(t),
						a = window.getComputedStyle(f),
						o = n(r.maxHeight) || Math.max(window.innerHeight - 32, 0),
						s =
							n(i.paddingTop) +
							n(i.paddingBottom) +
							n(i.rowGap) +
							(d?.offsetHeight || 0),
						c = n(a.maxHeight) || o,
						l = Math.max(Number(e) || 1, 0.01),
						p = Math.max(0, Math.min(f.clientWidth / l, c, Math.max(o - s, 0)));
					(f.style.blockSize = `${p}px`), (u.style.blockSize = `${p + s}px`);
				},
				D = (e) => {
					p = _(e);
					let l = g[p] || g[0],
						u = Number(l?.dataset.mediaAspectRatio) || 1;
					t.style.setProperty(`--product-detail-media-aspect-ratio`, String(u)),
						h
							? (n.style.transform = `translateX(-${p * 100}%)`)
							: (n.style.transform = ``),
						r.forEach((e, t) => {
							let n = g.includes(e),
								r = e === l;
							(e.hidden = !n),
								e.setAttribute(
									`aria-hidden`,
									n && (!h || r) ? `false` : `true`,
								),
								e.classList.toggle(`is-active`, r),
								(e.dataset.productMediaVisible = n ? `true` : `false`);
						}),
						i.forEach((e) => {
							let t = r.find((t) => t.dataset.mediaId === e.dataset.mediaId),
								n = t ? g.includes(t) : !0,
								i = t === l;
							(e.hidden = !n),
								e.classList.toggle(`is-active`, i),
								e.setAttribute(`aria-pressed`, i ? `true` : `false`);
						}),
						c.forEach((e) => {
							let t = r.find((t) => t.dataset.mediaId === e.dataset.mediaId),
								n = t ? g.includes(t) : !0,
								i = t === l;
							(e.hidden = !n),
								e.classList.toggle(`is-active`, i),
								i
									? e.setAttribute(`aria-current`, `true`)
									: e.removeAttribute(`aria-current`);
						}),
						s && (s.textContent = `Media ${p + 1} van ${g.length}`),
						a && (a.disabled = p === 0),
						o && (o.disabled = p === g.length - 1),
						T();
				},
				O = (e) => {
					let t = g.findIndex((t) => t.dataset.mediaId === e);
					D(t >= 0 ? t : 0);
				};
			a && a.addEventListener(`click`, () => D(p - 1)),
				o && o.addEventListener(`click`, () => D(p + 1)),
				i.forEach((e) => {
					e.addEventListener(`click`, () => {
						O(e.dataset.mediaId);
					});
				}),
				c.forEach((e) => {
					e.addEventListener(`click`, () => {
						O(e.dataset.mediaId);
					});
				}),
				t.addEventListener(`keydown`, (e) => {
					e.key === `ArrowLeft` && (e.preventDefault(), D(p - 1)),
						e.key === `ArrowRight` && (e.preventDefault(), D(p + 1));
				}),
				t.addEventListener(
					`touchstart`,
					(e) => {
						m = e.changedTouches[0].clientX;
					},
					{ passive: !0 },
				),
				t.addEventListener(
					`touchend`,
					(e) => {
						if (m === null) return;
						let t = e.changedTouches[0].clientX - m;
						(m = null), !(Math.abs(t) < 48) && D(t > 0 ? p - 1 : p + 1);
					},
					{ passive: !0 },
				),
				l &&
					l.addEventListener(`click`, () => {
						if (!u || !f) return;
						let t = g[p],
							n = t?.querySelector(`img, video, iframe, model-viewer`);
						if (!n) return;
						u.style.removeProperty(`block-size`),
							f.style.removeProperty(`block-size`),
							f.replaceChildren();
						let r = n.cloneNode(!0);
						if (
							(r.removeAttribute(`loading`),
							(r.className = `max-h-[calc(100dvh-8rem)] max-w-full object-contain`),
							r.tagName === `VIDEO` &&
								((r.controls = !0),
								(r.muted = e?.dataset.videoAutoplay === `true`),
								(r.loop = e?.dataset.videoLoop === `true`),
								e?.dataset.videoAutoplay === `true` && (r.autoplay = !0)),
							f.append(r),
							typeof u.showModal == `function`)
						) {
							u.showModal();
							let e = Number(t?.dataset.mediaAspectRatio) || 1;
							E(e), window.requestAnimationFrame(() => E(e));
						}
					}),
				d &&
					d.addEventListener(`click`, () => {
						u?.close();
					}),
				u &&
					u.addEventListener(`click`, (e) => {
						e.target === u && u.close();
					});
			let k = (e) =>
					String(e || ``)
						.toLowerCase()
						.replace(/&/g, ` and `)
						.replace(/[^a-z0-9]+/g, ` `)
						.trim(),
				A = (e) => {
					let t = new Set();
					return (
						e?.featured_media?.id && t.add(String(e.featured_media.id)),
						e?.featured_image?.id && t.add(String(e.featured_image.id)),
						e?.image?.id && t.add(String(e.image.id)),
						t
					);
				},
				j = (e) => k(e).replace(/\s+/g, ``),
				M = (e) => {
					let t = j(e?.sku),
						n = new Set();
					t.length >= 3 && n.add(t);
					let r = t.match(/^([a-z]*\d+)[a-z]+$/)?.[1];
					return r && r.length >= 3 && n.add(r), Array.from(n);
				},
				N = (e) => j(e.dataset.mediaSrc),
				P = (e) => k(e.dataset.mediaSrc).split(/\s+/).filter(Boolean),
				F = (e, t) => {
					let n = N(e);
					return t.some((e) => e !== `` && n.includes(e));
				},
				I = (e) => {
					let t = j(G(e)),
						n = [...M(e)];
					return t.length >= 3 && n.push(t), [...new Set(n)];
				},
				L = (e, t) => F(e, I(t)),
				R = (e, t) =>
					this.variants.some((n) =>
						String(n?.id) === String(t?.id) ? !1 : L(e, n),
					),
				z = (e) => {
					let t = P(e);
					return [
						`usp`,
						`schema`,
						`schematische`,
						`developed`,
						`expert`,
						`experts`,
						`airflow`,
						`optimal`,
						`leeftijd`,
						`maten`,
						`hqdefault`,
					].some((e) => t.includes(e));
				},
				B = (e) => {
					let t = [],
						n = String(e.dataset.mediaAlt || ``).toLowerCase();
					k(e.dataset.mediaAlt).includes(`all groups`) && t.push(`all`);
					let r =
							/(?:media\s+group|variant|group|colour|color|kleur)\s*[:=_-]\s*([a-z0-9][a-z0-9 _-]*?)(?=$|[,;|\\]])/g,
						i = r.exec(n);
					for (; i; ) t.push(k(i[1])), (i = r.exec(n));
					return t;
				},
				V = (e) => B(e).length > 0,
				H = () => r.some((e) => V(e)),
				U = (e) => {
					if (k(e.dataset.mediaAlt).includes(`all markets`)) return [`all`];
					let t = String(e.dataset.mediaAlt || ``).toLowerCase(),
						n = [],
						r = /(?:market|markt)\s*[:=_-]?\s*([a-z]{2}|[a-z0-9-]+)/g,
						i = r.exec(t);
					for (; i; ) n.push(k(i[1])), (i = r.exec(t));
					return n;
				},
				W = (e, t) => {
					let n = U(e);
					return n.length === 0 || n.includes(`all`)
						? !0
						: n.some((e) => t.includes(e));
				},
				G = (t) => {
					if (!t) return ``;
					let n = String(e?.dataset.variantOptionLabels || ``)
							.split(`,`)
							.map(k)
							.filter(Boolean),
						r = this.optionNames.findIndex((e) => n.includes(k(e)));
					return r >= 0 && t.options?.[r]
						? t.options[r]
						: t.option1 || t.options?.[0] || ``;
				},
				K = (t, n) => {
					if (e?.dataset.filterSelectedVariantMedia !== `true`) return !0;
					let r = A(n),
						i = String(t.dataset.mediaId || ``);
					if (r.has(i)) return !0;
					let a = B(t);
					if (a.includes(`all`) || L(t, n) || z(t)) return !0;
					let o = k(G(n));
					if (a.length > 0) return o !== `` && a.includes(o);
					if (o !== ``) {
						let e = j(o);
						if (F(t, [e])) return !0;
					}
					return H() ? !1 : !R(t, n);
				},
				q = (e) => {
					let t = A(e);
					return t.size === 0
						? -1
						: g.findIndex((e) => t.has(String(e.dataset.mediaId || ``)));
				},
				J = (t, { reset: n = !0 } = {}) => {
					let i = g[p],
						a = k(e?.dataset.currentMarket),
						o = k(e?.dataset.currentMarketCode),
						s = k(e?.dataset.defaultMarket || `nl`),
						c = [a, o].filter(Boolean),
						l = [s].filter(Boolean),
						u = r.filter((e) => K(e, t)),
						d = u.length > 0 ? u : r,
						f = d.filter((e) => W(e, c));
					f.length === 0 && (f = d.filter((e) => W(e, l))),
						(g = f.length > 0 ? f : d);
					let m = q(t);
					(p = n && m >= 0 ? m : n || !g.includes(i) ? 0 : g.indexOf(i)), D(p);
				};
			this.gallery = { filterMedia: J, setActive: D };
			let Y = this.form?.querySelector(`[data-variant-id]`)?.value;
			J(
				this.variants.find((e) => String(e.id) === String(Y)),
				{ reset: !0 },
			);
		}
		bindKeyFeatures() {
			this.section
				.querySelectorAll(`[data-product-key-features]`)
				.forEach((e) => {
					if (e.dataset.productKeyFeaturesReady === `true`) return;
					e.dataset.productKeyFeaturesReady = `true`;
					let t = e.querySelector(`[data-product-key-features-track]`),
						n = Array.from(
							e.querySelectorAll(`[data-product-key-features-slide]`),
						);
					if (!t || n.length === 0) return;
					let r = e.querySelector(`[data-product-key-features-prev]`),
						i = e.querySelector(`[data-product-key-features-next]`),
						a = Array.from(
							e.querySelectorAll(`[data-product-key-features-dot]`),
						),
						o = e.querySelector(`[data-product-key-features-status]`),
						s = e.querySelector(`.product-key-features__carousel`),
						c = e.dataset.videoAutoplay === `true`,
						l = 0,
						u = (e) => {
							!e || typeof e.play != `function` || e.play().catch(() => {});
						},
						d = () => {
							n.forEach((e, t) => {
								e.querySelectorAll(`video`).forEach((e) => {
									if (t === l && c) {
										(e.muted = !0), u(e);
										return;
									}
									e.pause();
								});
							});
						},
						f = (e) => {
							(l = Math.max(0, Math.min(e, n.length - 1))),
								(t.style.transform = `translateX(-${l * 100}%)`),
								n.forEach((e, t) => {
									e.toggleAttribute(`aria-hidden`, t !== l);
								}),
								a.forEach((e, t) => {
									e.classList.toggle(`is-active`, t === l),
										t === l
											? e.setAttribute(`aria-current`, `true`)
											: e.removeAttribute(`aria-current`);
								}),
								r && (r.disabled = l === 0),
								i && (i.disabled = l === n.length - 1),
								o && (o.textContent = `Feature ${l + 1} van ${n.length}`),
								d();
						};
					r?.addEventListener(`click`, () => f(l - 1)),
						i?.addEventListener(`click`, () => f(l + 1)),
						a.forEach((e) => {
							e.addEventListener(`click`, () => {
								f(Number(e.dataset.productKeyFeaturesIndex) || 0);
							});
						}),
						s?.addEventListener(`keydown`, (e) => {
							(e.key !== `ArrowLeft` && e.key !== `ArrowRight`) ||
								(e.preventDefault(), f(l + (e.key === `ArrowRight` ? 1 : -1)));
						}),
						e
							.querySelectorAll(`[data-product-key-features-play]`)
							.forEach((e) => {
								e.addEventListener(`click`, () => {
									let t = e.parentElement?.querySelector(`video`);
									t && ((e.hidden = !0), (t.controls = !0), u(t));
								});
							}),
						e.querySelectorAll(`video`).forEach((e) => {
							e.addEventListener(`ended`, () => {
								let t = e.parentElement?.querySelector(
									`[data-product-key-features-play]`,
								);
								t && (t.hidden = !1);
							});
						}),
						f(0);
				});
		}
		bindQuantity() {
			let e = this.section.querySelector(`input[name="quantity"]`),
				t = this.section.querySelector(`[data-quantity-decrease]`),
				n = this.section.querySelector(`[data-quantity-increase]`);
			if (!e) return;
			let r = (t) => {
				e.value = Math.max(1, Number(t) || 1);
			};
			t && t.addEventListener(`click`, () => r(Number(e.value) - 1)),
				n && n.addEventListener(`click`, () => r(Number(e.value) + 1)),
				e.addEventListener(`change`, () => r(e.value));
		}
		bindAddToCart() {
			this.form &&
				this.form.addEventListener(
					`submit`,
					(e) => {
						this.handleAddToCartSubmit(e);
					},
					{ capture: !0 },
				);
		}
		async handleAddToCartSubmit(i) {
			if (!r(i.target) || !e(t())) return;
			i.preventDefault(), i.stopPropagation();
			let a = i.target,
				o = document.activeElement,
				s = this.form.querySelector(`[data-add-to-cart]`),
				c = this.section.querySelector(`[data-sticky-add-to-cart]`),
				l = this.section.querySelector(`[data-product-add-status]`),
				u = (e) => {
					[s, c].forEach((t) => {
						if (!t) return;
						e
							? t.setAttribute(`aria-busy`, `true`)
							: t.removeAttribute(`aria-busy`);
						let n = t.querySelector(
							`[data-add-to-cart-text], [data-sticky-add-to-cart-text]`,
						);
						if (e) {
							n &&
								((n.dataset.idleText = n.textContent?.trim() || ``),
								(n.textContent = `${n.dataset.idleText}…`)),
								(t.disabled = !0);
							return;
						}
						n?.dataset.idleText !== void 0 &&
							((n.textContent = n.dataset.idleText), delete n.dataset.idleText);
						let r = a.querySelector(`[data-variant-id]`)?.value;
						t.disabled = !this.variants.find((e) => String(e.id) === String(r))
							?.available;
					});
				};
			l && (l.textContent = ``);
			try {
				await n(a, {
					onPending: u,
					openDrawer: async ({ sectionHtml: e }) => {
						if (window.DifraxCartDrawer?.openRendered) {
							await window.DifraxCartDrawer.openRendered(e, o);
							return;
						}
						document.dispatchEvent(new CustomEvent(`cart:open`));
					},
				});
			} catch (e) {
				console.warn(`Unable to add product`, e),
					l &&
						(l.textContent = l.dataset.errorMessage || `Unable to add product`);
			}
		}
		bindStickyAtc() {
			let e = this.section.querySelector(`[data-sticky-atc]`),
				t = this.form?.querySelector(`[data-add-to-cart]`);
			if (!e || !t) return;
			let n = !1,
				r,
				i = (t) => {
					if (t !== n) {
						if (((n = t), window.clearTimeout(r), t)) {
							(e.hidden = !1),
								window.requestAnimationFrame(() => {
									n && e.classList.add(`is-visible`);
								});
							return;
						}
						e.classList.remove(`is-visible`),
							(r = window.setTimeout(() => {
								n || (e.hidden = !0);
							}, 220));
					}
				},
				a = () => {
					let e = t.getBoundingClientRect().bottom <= 0;
					i(e);
				};
			`IntersectionObserver` in window &&
				new IntersectionObserver(a, { threshold: 0 }).observe(t),
				window.addEventListener(`scroll`, a, { passive: !0 }),
				window.addEventListener(`resize`, a),
				a();
		}
		bindVariants() {
			if (!this.form || this.variants.length === 0) return;
			let e = Array.from(this.form.querySelectorAll(`[data-option-input]`)),
				t = Array.from(this.form.querySelectorAll(`[data-option-group]`)),
				n = Array.from(
					this.form.querySelectorAll(`[data-option-value-button]`),
				),
				r = this.form.querySelector(`[data-variant-id]`),
				i = this.form.querySelector(`[data-product-price]`),
				o = this.form.querySelector(`[data-compare-price]`),
				s = this.form.querySelector(`[data-add-to-cart]`),
				c = this.form.querySelector(`[data-add-to-cart-text]`),
				l = this.form.querySelector(`[data-discount-badge]`),
				u = this.section.dataset.dynamicAvailability || `show`,
				d = () => {
					let t = Array.from({ length: this.optionNames.length }, () => ``);
					return (
						e.forEach((e) => {
							let n = Number(e.dataset.optionPosition);
							if (Number.isInteger(n)) {
								if (e.tagName === `SELECT`) {
									t[n] = e.value;
									return;
								}
								e.checked && (t[n] = e.value);
							}
						}),
						t
					);
				},
				f = (e, t) => t.every((t, n) => t === `` || e.options?.[n] === t),
				p = (e) => this.variants.find((t) => f(t, e)),
				m = (e, t, n) =>
					this.variants.some((r) =>
						!r.available || r.options?.[e] !== t
							? !1
							: n.every((t, n) =>
									n === e || t === `` ? !0 : r.options?.[n] === t,
								),
					),
				h = (e) => !e.inventory_management || Number(e.inventory_quantity) > 0,
				g = (e, t, n) => {
					let r = this.variants.filter((r) =>
						r.options?.[e] === t
							? n.every((t, n) =>
									n === e || t === `` ? !0 : r.options?.[n] === t,
								)
							: !1,
					);
					return r.length > 0 && r.every((e) => !h(e));
				},
				_ = () => {
					n.forEach((e) => {
						let t = !!e.querySelector(`[data-option-input]`)?.checked;
						e.classList.toggle(`is-active`, t),
							e.classList.toggle(`is-selected`, t);
					});
				},
				v = (e, t) => {
					if (e) {
						if (e.tagName === `OPTION`) {
							e.disabled = t;
							return;
						}
						e.disabled = t;
					}
				},
				y = () => {
					if (u === `off`) {
						e.forEach((e) => {
							v(e, !1),
								e
									.closest(`[data-option-value-button]`)
									?.removeAttribute(`hidden`);
						}),
							Array.from(this.form.querySelectorAll(`option`)).forEach((e) => {
								e.disabled = !1;
							});
						return;
					}
					let r = d();
					n.forEach((e) => {
						let t = e.querySelector(`[data-option-input]`),
							n = Number(e.dataset.optionPosition),
							i = e.dataset.optionValue || t?.value || ``,
							a = m(n, i, r),
							o = g(n, i, r),
							s = a || o;
						v(t, !s),
							e.classList.toggle(`is-unavailable`, !a || o),
							s
								? e.removeAttribute(`aria-disabled`)
								: e.setAttribute(`aria-disabled`, `true`),
							e.toggleAttribute(`hidden`, u === `prune` && !s);
					}),
						Array.from(
							this.form.querySelectorAll(`select[data-option-input]`),
						).forEach((e) => {
							let t = Number(e.dataset.optionPosition);
							if (
								(Array.from(e.options).forEach((e) => {
									let n = m(t, e.value, r),
										i = g(t, e.value, r);
									(e.disabled = !n && !i),
										(e.hidden = u === `prune` && e.disabled);
								}),
								e.selectedOptions[0]?.disabled)
							) {
								let t = Array.from(e.options).find((e) => !e.disabled);
								t && (e.value = t.value);
							}
						}),
						t.forEach((e) => {
							let t = Array.from(
								e.querySelectorAll(`input[type="radio"][data-option-input]`),
							);
							if (t.length === 0 || t.some((e) => e.checked && !e.disabled))
								return;
							let n = t.find((e) => !e.disabled);
							n && (n.checked = !0);
						});
				},
				b = ({ resetMedia: e = !0 } = {}) => {
					y(), _();
					let t = d(),
						n = p(t);
					if (!n) {
						s && (s.disabled = !0),
							this.syncStickyAtc(null),
							this.syncVariantDetailBlocks(null),
							this.syncArticleNumber(null);
						return;
					}
					if (
						(r && (r.value = n.id),
						i && (i.textContent = a(n.price, this.moneyFormat)),
						o)
					) {
						let e = n.compare_at_price && n.compare_at_price > n.price;
						(o.hidden = !e),
							(o.textContent = e
								? a(n.compare_at_price, this.moneyFormat)
								: ``);
					}
					if (l) {
						let e = n.compare_at_price && n.compare_at_price > n.price;
						if (((l.hidden = !e), e)) {
							let e = Math.round(
									((n.compare_at_price - n.price) * 100) / n.compare_at_price,
								),
								t = l.dataset.discountTemplate || `[percent]% korting`;
							l.textContent = t
								.replace(`[percent]`, String(e))
								.replace(`{{ percent }}`, String(e));
						}
					}
					s && (s.disabled = !n.available),
						c &&
							(c.textContent = n.available
								? c.dataset.availableText || c.textContent
								: c.dataset.soldOutText || `Uitverkocht`),
						this.gallery?.filterMedia(n, { reset: e }),
						this.syncStickyAtc(n),
						this.syncVariantDetailBlocks(n),
						this.syncArticleNumber(n);
				};
			e.forEach((e) => {
				e.addEventListener(`change`, () => b({ resetMedia: !0 }));
			}),
				b({ resetMedia: !1 });
		}
	}
	i.register({
		name: `product-detail`,
		selector: `[data-product-detail]`,
		init(e) {
			new o(e);
		},
	});
})();
